import { AUSTRALIA, AUSTRALIA_ISO } from '@/constants/general-words.const';
import { Address } from '@/interfaces';
import { RACQAddressResult } from '@/interfaces/entities/experian-results.interface';
import { normalizeCsv, toSafeDisplayPostcode } from '@/utils/convert';
import { isPOBoxAddress, isPostalAddress } from '@/utils/regex-helpers';

export function mapAddressResultToIdentityAddress(result: RACQAddressResult, isPostal: boolean): Address {
  return {
    addressType: isPostal ? 'Postal' : '',
    dpid: result.dpid ? result.dpid : '',
    postalDeliveryType: isPOBoxAddress(result.street ?? '') ? 'PO Box' : '',

    unit: result.unitNumber ?? '',
    streetNumber: result.streetNumber ?? '', //PO Box should be enterered in the street field.
    street: result.street ?? '',
    suburb: result.suburb ?? '',
    postcode: result.postcode ?? '',
    state: result.state ?? '',
    country: result.country ?? result.countryISO ?? '',
    formattedStreet: result.addressLine ?? '',
    formattedLong: result.addressLine ?? '',
    unitType: result.buildingName ?? '', // as per sitecore 8
    buildingLevel: result.buildingLevel ?? '',
  };
}

export function mapIdentityAddressToAddressResult(address: Address): RACQAddressResult | undefined {
  if (!address) return {};
  return {
    dpid: address.dpid !== null ? address.dpid : undefined,
    unitNumber: address.unit || undefined,
    buildingName: address.unitType || undefined, //as per Sitecore 8
    buildingLevel: address.buildingLevel || undefined,
    streetNumber: address.streetNumber || undefined,
    street: address.street,
    suburb: address.suburb || undefined,
    postcode: address.postcode || undefined,
    state: address.state || undefined,
    country: address.country || undefined,
    addressLine: address.formattedLong || address.formattedStreet || undefined,
  };
}
